import React from "react";
import "./Brand.css";
const Brands = () => {
  return (
    <section className="brands_sections">
      <h1 className="text_brand">The Brands that we Deal Into</h1>
      <div className="brand_section">
        <div className="brands">
          <img
            className="brand_image"
            src="images/rathi.jpg"
            alt="brandimage"
          />
          <h1 className="brand_title">Rathi</h1>
        </div>
        <div className="brands">
          <img className="brand_image" src="images/sail.jpg" alt="brandimage" />
          <h1 className="brand_title">Sail</h1>
        </div>
        <div className="brands">
          <img className="brand_image" src="images/SBF.png" alt="brandimage" />
          <h1 className="brand_title">SBF Rapid </h1>
        </div>
        <div className="brands">
          <img
            className="brand_image"
            src="images/NeoSteel.jpg"
            alt="brandimage"
          />
          <h1 className="brand_title">JSW NeoSteel</h1>
        </div>
        <div className="brands">
          <img
            className="brand_image"
            src="images/one_tmt.png"
            alt="brandimage"
          />
          <h1 className="brand_title">JSW ONE TMT</h1>
        </div>
      </div>
    </section>
  );
};

export default Brands;
